module.exports = require("core-js/library/fn/object/define-properties");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/define-properties.js
// module id = 236
// module chunks = 0 1